import * as React from "react";

export interface BodyProps {
  style?: React.CSSProperties;
  children?: any;
}

export default (props: BodyProps) => (
  <div className="modal-body" style={props.style}>
    {props.children}
  </div>
);
